import ApiRequest from '../../../Apis/request'

export default class ApiAGS {
  constructor() {
    this.apiRequest = new ApiRequest()
  }
  async update(payload) {
    try {
      const { id, ...data } = payload
      const res = await this.apiRequest.put(`ags1a/${id}`, data)
      return res
    } catch (error) {
      return error.response
    }
  }
  async preview(agId) {
    try {
      const res = await this.apiRequest.get(`pvags/${agId}/preview`)
      return res
    } catch (error) {
      return error.response
    }
  }
}
